<form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()">
  <div>
    <ion-input
      formControlName="phone"
      (ionInput)="onPhoneInput($event)"
      [label]="otpLoginContent[0]"
      label-placement="floating"
      fill="outline"
      [placeholder]="otpLoginContent[1]"
    ></ion-input>
    <div
      *ngIf="
        otpForm.get('phone')?.invalid &&
        (otpForm.get('phone')?.touched || otpForm.get('phone')?.dirty)
      "
      class="error-head"
    >
      <small
        class="error-message"
        *ngIf="otpForm.get('phone')?.errors?.['required']"
        >{{otpLoginContent[2]}}</small
      >
      <small
        class="error-message"
        *ngIf="otpForm.get('phone')?.errors?.['minlength']"
        >{{otpLoginContent[3]}}</small
      >
    </div>
    <ion-input
      formControlName="code"
      *ngIf="otpSent"
      class="space-input"
      [label]="otpLoginContent[4]"
      label-placement="floating"
      fill="outline"
      [placeholder]="otpLoginContent[5]"
    ></ion-input>
  </div>
  <div class="resend-otp-container" *ngIf="otpSent">
    <ion-button
      *ngIf="canResendOtp"
      class="resend-otp-button"
      [disabled]="!canResendOtp"
      size="small"
      color="primary"
      fill="outline"
      (click)="sendVerifyOtp('send')"
    >
      {{otpLoginContent[9]}}
    </ion-button>
    <p *ngIf="countdown > 0" class="resend-otp-text">
      {{otpLoginContent[7]}} {{ countdown }} seconds.
    </p>
  </div>
  <ion-button
    type="submit"
    color="primary"
    expand="full"
    class="otp-button"
    [disabled]="otpForm.invalid"
  >
      {{ otpSent ? otpLoginContent[8] : otpLoginContent[6] }}
  </ion-button>
</form>
